<nav #navbar class="navbar" [ngClass]="isNavbarShow ? 'active' : 'inactive'">
  <div class="container-fluid">
    <div class="navbar-header">
      <a href="#" onClick="return false;" class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <!-- mobile menu bars -->
      <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
      <a class="navbar-brand" routerLink="/">
        <img class="nav-brand-icon" alt="DEXIO" title="DEXIO" />
      </a>
    </div>
    <div class="collapse navbar-collapse" [ngClass]="isNavbarCollapsed ? '' : 'show'">
      <ul class="pull-left collapse-menu-icon">
        <li class="menuBtn">
          <button mat-button (click)="callSidemenuCollapse()" class="sidemenu-collapse nav-notification-icons">
            <app-feather-icons [icon]="'menu'" [class]="'header-icon'"></app-feather-icons>
          </button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        
        <!-- Version -->
        <li title="Current Version: {{appVersion}}" class="me-3">
          {{(appVersion!="") ? "v" + appVersion: ""}}
        </li>
        <!-- #END# Version -->

        <!-- Help Button -->
        <li class="nav-item help">
          <button mat-button [matMenuTriggerFor]="helpmenu">
            <div class="chip dropdown-toggle" ngbDropdownToggle class="">
              <app-feather-icons [icon]="'help-circle'" [class]="'help-icon'"></app-feather-icons>
            </div>
          </button>
          <mat-menu #helpmenu="matMenu" class="help-menu">
            <div class="noti-list">
              <div class="menu ">
                <div class="help_dw_menu">
                  <a mat-menu-item *ngFor="let helpDoc of helpDocuments" class="help-item-list" target="dexio_help" [href]="helpDoc.location">
                    {{helpDoc.title}}
                  </a>
                </div>
              </div>
            </div>
          </mat-menu>
        </li>
        <!-- #END# Help Button -->

        <!-- Full Screen Button -->
        <li class="fullscreen">
          <button mat-button class="nav-notification-icons" (click)="callFullscreen()">
            <app-feather-icons [icon]="'maximize'" [class]="'header-icon'"></app-feather-icons>
          </button>
        </li>
        <!-- #END# Full Screen Button -->
        
        <!-- Settings -->
        <li class="nav-item app_settings">
          <button mat-button [matMenuTriggerFor]="settingsmenu">
            <div class="chip dropdown-toggle" ngbDropdownToggle class="">
              <app-feather-icons [icon]="'settings'" [class]="'header-icon'"></app-feather-icons>
            </div>
          </button>
          <mat-menu #settingsmenu="matMenu" class="settings-menu">
            <div class="noti-list">
              <div class="menu ">
                <div class="settings_dw_menu">
                  <div class="flex flex-wrap hiddenradio">
                    <div class="flex flex-col ms-5 mt-3">
                      <label>
                        <input type="radio" name="value" value="light" [checked]="isDarTheme === false ? true : false"
                          (click)="lightThemeBtnClick()">
                        <img src="assets/images/light.png">
                      </label>
                      <div class="mt-1 text-md text-center"> Light </div>
                    </div>
                    <div class="flex flex-col ms-5 mt-3"> <label>
                        <input type="radio" name="value" value="dark" [checked]="isDarTheme === true ? true : false"
                          (click)="darkThemeBtnClick()">
                        <img src="assets/images/dark.png">
                      </label>
                      <div class="mt-1 text-md text-center"> Dark </div>
                    </div>
                  </div>
                </div>
                </div>
            </div>
          </mat-menu>
        </li>
        <!-- #END# Settings -->
        
        <!-- Logged In User -->
        <li class="nav-item user_profile" *ngIf="userName!=''">
          <button mat-button [matMenuTriggerFor]="profilemenu">
            <div class="chip dropdown-toggle" ngbDropdownToggle class="">
              <app-feather-icons [icon]="'user'" [class]="'header-icon'"></app-feather-icons>
            </div>
          </button>
          <mat-menu #profilemenu="matMenu" class="profile-menu">
            <div class="noti-list">
              <div class="menu ">
                <div class="user_dw_menu">
                  <div class="p-3 pb-1">
                    Hello, {{ userName }}!
                  </div>
                  <hr />
                  <!-- <button mat-menu-item class="user-item-list disabled text-muted">
                    <app-feather-icons [icon]="'user'" [class]="'user-menu-icons'"></app-feather-icons>Account
                  </button>
                  <button mat-menu-item class="user-item-list disabled text-muted">
                    <app-feather-icons [icon]="'mail'" [class]="'user-menu-icons'"></app-feather-icons>Inbox
                  </button>
                  <button mat-menu-item class="user-item-list disabled text-muted">
                    <app-feather-icons [icon]="'settings'" [class]="'user-menu-icons'"></app-feather-icons>Settings
                  </button> -->
                  <button mat-menu-item (click)="logout()" class="user-item-list">
                    <app-feather-icons [icon]="'log-out'" [class]="'user-menu-icons'"></app-feather-icons>Logout
                  </button>
                </div>
              </div>
            </div>
          </mat-menu>
        </li>
        <!-- #END# Logged In User -->
      </ul>
    </div>
  </div>
</nav>